import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CountService } from '../../../shared/service/count.service';
import { Router } from '@angular/router';
import { PoButtonModule, PoContainerModule, PoFieldModule, PoLoadingModule, PoModalAction, PoModalComponent, PoModalModule, PoPageModule, PoSelectOption, PoTooltipModule, PoWidgetModule } from '@po-ui/ng-components';
import { TokenService } from '../../../shared/service/token.service';
import { UserTerminalService } from '../../../shared/service/user-terminal.service';
import { OrderModel } from '../../../models/order.model';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FilterButtonComponent } from '../../../shared/components/filter-button/filter-button.component';
import { FilterDropdownComponent } from '../../../shared/components/filter-dropdown/filter-dropdown.component';
import { OrderCountModel } from '../../../models/order-count.model';
import { OrderCountListComponent } from './order-count-list/order-count-list.component';
import { ToasterService } from '../../../shared/service/toaster.service';
import { FixedRoundButtonComponent } from '../../../shared/components/fixed-round-button/fixed-round-button.component';

@Component({
  selector: 'app-order-count-header',
  imports: [FormsModule,
    PoModalModule,
    PoPageModule,
    PoWidgetModule,
    PoFieldModule,
    PoButtonModule,
    PoContainerModule,
    CommonModule,
    PoLoadingModule,
    PoTooltipModule,
    ReactiveFormsModule,
    FilterButtonComponent,
    FilterDropdownComponent,
    OrderCountListComponent,
    FixedRoundButtonComponent],
  templateUrl: './order-count-header.component.html',
  styleUrl: './order-count-header.component.css'
})
export class OrderCountHeaderComponent implements OnInit, AfterViewInit {
  @ViewChild('poModalNewOrderCount', { static: false }) poModalNewOrderCount!: PoModalComponent;
  @Input() terminalSelected!: string;
  @Input() orderModel!: OrderModel;
  @Output() onTerminalModalOpen = new EventEmitter();
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() orderCountSelected = new EventEmitter<OrderCountModel>();

  fadeInAnimation = false;
  nullFilter = false;
  seeFilter: boolean = false;
  itemFilter: string = '1';
  orderCodeFilter: string = '';
  countSequenceFilter: string = '';
  itemsListCount: OrderCountModel[] = [];
  itemsListCountFilter: OrderCountModel[] = [];
  statusDefault: string = '';
  terminalList: any = [{ label: 'default', value: '0' }];
  size = 'sm';
  text = 'Carregando';
  sortAsc = true;
  funnelIcon = 'an an-funnel-simple';
  funnelIconFill = 'an an-arrow-down';
  newOrderCountForm!: FormGroup;
  showNewCountButton = true;
  isNewCountButtonDisabled: boolean = true;
  primaryAction: PoModalAction = {
    action: () => {
      this.showNewCountButton = false;
      this.onSubmitNewOrderCountForm();
    },
    label: 'Criar',
  };
  secondaryAction: PoModalAction = {
    action: () => {
      this.showNewCountButton = true;
      this.poModalNewOrderCount.close();
      this.newOrderCountForm.patchValue({
        orderCountDescription: null
      });
    },
    label: 'Cancelar'
  };
  readonly statusItens: Array<PoSelectOption> = [
    { label: 'Em Andamento', value: '1' },
    { label: 'Atendida', value: '4' },
    { label: 'Encerrada', value: '5' }
  ];

  constructor(
    private tokenService: TokenService,
    private cdRef: ChangeDetectorRef,
    private userTerminalService: UserTerminalService,
    private countService: CountService,
    private toasterService: ToasterService,
    private fb: FormBuilder
  ) { }
  ngOnInit(): void {
    this.newOrderCountForm = this.fb.group({
      orderCountDescription: ['', Validators.required]
    });
  }
  ngAfterViewInit(): void {
    var userTerminal = this.userTerminalService.getByLoggedUser();

    if (userTerminal == null) {
      this.onTerminalModalOpen.emit();
      return;
    }

    this.terminalSelected = String(userTerminal!.TerminalCode);
    this.getOrderCounts();
    this.cdRef.detectChanges();
  }

  getOrderCounts() {
    this.isInLoad(true);
    const loggedBranchCode = Number(this.tokenService.getBranch());
    this.countService.getCountList(loggedBranchCode, Number(this.terminalSelected), this.orderModel.orderCode).subscribe({
      next: (response) => {
        this.isInLoad(false);
        this.itemsListCount = this.getOnlyCounts(response.items);
        if (this.itemsListCount.length === 0) {
          this.toasterService.triggerAlert('Nenhuma contagem encontrada! Você pode iniciar uma nova contagem clicando no botão "+"', 'warning');
        }
        this.onFilter();
        this.executeFadeInAnimation();
      }, error: (error) => {
        this.isInLoad(false);
        const errorMessage = error?.error?.[0]?.message ?? `Não foi possível obter as contagens do pedido ${this.orderModel.orderCode}`;
        this.toasterService.triggerAlert(errorMessage, 'error');
      }
    });
  }

  getOnlyCounts(counts: OrderCountModel[]) {
    return counts.filter((item) => item.countCode > 0);
  }

  executeFadeInAnimation() {
    this.fadeInAnimation = false;
    setTimeout(() => {
      this.fadeInAnimation = true;
    }, 10);
  }

  loading(value: boolean) {
    this.isLoading.emit(value);
  }

  onOrderCountSelected(item: OrderCountModel) {
    this.orderCountSelected.emit(item);
  }

  onFilter() {
    this.nullFilter = false;
    let filteredItemsList = this.itemsListCount.filter((item) => item.countStatus.value === parseInt(this.itemFilter));
    if (this.orderCodeFilter != null && this.orderCodeFilter != '')
      filteredItemsList = filteredItemsList.filter((item) => item.orderCode?.toString().includes(this.orderCodeFilter));

    if (this.countSequenceFilter != null && this.countSequenceFilter != '')
      filteredItemsList = filteredItemsList.filter((item) => item.countCode?.toString().includes(this.countSequenceFilter));

    if (filteredItemsList.length > 0) {
      this.itemsListCountFilter = filteredItemsList;
      this.nullFilter = false;
    } else {
      this.itemsListCountFilter = [];
      this.nullFilter = true;
      this.toasterService.triggerAlert('Nenhum item encontrado. Você pode iniciar uma nova contagem clicando no botão "+"', 'warning');
    }
    this.sortByOrderDate();
    this.executeFadeInAnimation();
  }

  onClick() {
    this.seeFilter = !this.seeFilter;
  }

  recoverStatusSelected(event: any) {
    this.itemFilter = event;
  }

  setOrderCodeFilter(event: any) {
    this.orderCodeFilter = event;
  }

  setCountSequenceFilter(event: any) {
    this.countSequenceFilter = event;
  }

  changeSort() {
    this.sortAsc = !this.sortAsc;
    this.sortByOrderDate();
  }

  sortByOrderDate() {
    this.itemsListCountFilter.sort((a: any, b: any) => this.sortAsc ? (new Date(a.orderDate).getTime() - new Date(b.orderDate).getTime()) : (new Date(b.orderDate).getTime() - new Date(a.orderDate).getTime()));
  }

  cleanFilter() {
    this.orderCodeFilter = '';
    this.countSequenceFilter = '';
    this.itemFilter = '1';
    this.itemsListCountFilter = this.itemsListCount.filter((item: any) => item.countStatus.value === parseInt(this.itemFilter))
    this.nullFilter = false;
    this.sortAsc = true;
    this.executeFadeInAnimation();
  }

  openModalNewOrderCount() {
    this.showNewCountButton = false;
    this.poModalNewOrderCount.open();
  }

  onSubmitNewOrderCountForm() {
    this.newOrderCountForm.markAllAsTouched();
    this.newOrderCountForm.updateValueAndValidity();

    if (this.newOrderCountForm.invalid) {
      this.newOrderCountForm.markAllAsTouched();
      this.newOrderCountForm.get('orderCountDescription')?.updateValueAndValidity();
      return;
    }
    this.poModalNewOrderCount.close();
    this.newOrderCount();
  }

  newOrderCount() {
    if (this.isNewCountButtonDisabled) return;
    this.isInLoad(true);
    const loggedBranchCode = Number(this.tokenService.getBranch());
    const orderCountDescriptionParam = (this.newOrderCountForm.get('orderCountDescription')?.value ?? '') as string;
    this.countService.postCreateOrderCount(loggedBranchCode, Number(this.terminalSelected), this.orderModel.orderCode, this.orderModel.orderSequence, loggedBranchCode, orderCountDescriptionParam)
      .subscribe({
        next: (response) => {
          this.isInLoad(false);
          this.onOrderCountSelected(response);
        }, error: (error) => {
          this.isInLoad(false);
          const errorMessage = error?.error?.[0]?.message ?? `Não foi possível criar a contagem para o pedido ${this.orderModel.orderCode}`;
          this.toasterService.triggerAlert(errorMessage, 'error');
        }
      });
  }

  isOrderCountFormInvalid(): boolean {
    if (this.newOrderCountForm === undefined) return false;

    return (this.newOrderCountForm.get('orderCountDescription')?.invalid &&
      this.newOrderCountForm.get('orderCountDescription')?.touched) ?? true;
  }

  isInLoad(value: boolean) {
    this.isNewCountButtonDisabled = value;
    this.loading(value);
  }

  hasOpenCounts(): boolean {
    return this.itemsListCount.some(count => count.countStatus.value === 1);
  }
}
